import React from "react";
import AddWordCardState, { AddWordCardProps } from "./AddWordCard.models";
import addWordCardImage from '../../assest/images/card-image/addLeitner.png'
import './AddWordCard.scss';
import FlashCardService from "../../services/content/FlashCardService";
import { CreateFlashCardDTO } from "../../models/dtos/content/leitner/CreateFlashCardDTO";

export default class AddWordCard extends React.PureComponent<AddWordCardProps, AddWordCardState>{
    flashCardService: FlashCardService;
    constructor(props: AddWordCardProps) {
        super(props);
        this.flashCardService = new FlashCardService();
        this.state = { boxId: '', createFlashCardDTO: { definition: '', mean: '', word: '', leitnerBoxId: '' } };
    }

    componentDidMount() {
        if (this.props.boxId !== null && this.props.boxId !== undefined)
            this.setState({ boxId: this.props.boxId });
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.statusPage !== this.props.boxId && this.props.boxId !== null && this.props.boxId !== undefined)
            this.setState({ boxId: this.props.boxId });
    }

    create = () => {
        let state = this;
        this.flashCardService.create({ definition: this.state.createFlashCardDTO.definition, mean: this.state.createFlashCardDTO.mean, word: this.state.createFlashCardDTO.word, leitnerBoxId: this.state.boxId }).then(response => {
            // eslint-disable-next-line no-restricted-globals
            state.setState({ createFlashCardDTO: { definition: '', mean: '', word: '' } });
        });
    }

    render(): React.ReactNode {
        let { createFlashCardDTO } = this.state;
        return <>
            <div className="col-12 add-word-card-area">
                <div className="tk-card">
                    <div className="card-icon">
                        <img src={addWordCardImage} alt="pencil icon" />
                    </div>
                    <div className="card-title">
                        <label>اطلاعات عبارت</label>
                    </div>
                    <div className="col-12 user-info">
                        <div className="tk-inline">
                            <div className="col-12 notspace">
                                <label>کلمه یا عبارت (اجباری)</label>
                            </div>
                        </div>
                        <div className="tk-inline ">
                            <div className="col-12 notspace">
                                <input type={"text"} className="form-control" value={createFlashCardDTO.word} onChange={e => this.setState((prevState) => {
                                    return { createFlashCardDTO: { ...prevState.createFlashCardDTO, word: e.target.value } }
                                })} placeholder="کلمه یا عبارت را وارد کنید" />
                            </div>
                        </div>
                        <div className="tk-inline pt-2">
                            <div className="col-12 notspace">
                                <label>معنا (اجباری)</label>
                            </div>
                        </div>
                        <div className="tk-inline">
                            <div className="col-12 notspace">
                                <input type={"text"} className="form-control" value={createFlashCardDTO.mean} onChange={e => this.setState((prevState) => {
                                    return { createFlashCardDTO: { ...prevState.createFlashCardDTO, mean: e.target.value } }
                                })} placeholder="معنای کلمه یا عبارت" />
                            </div>
                        </div>
                        <div className="tk-inline pt-2">
                            <div className="col-12 notspace">
                                <label>تعریف (اجباری)</label>
                            </div>
                        </div>
                        <div className="tk-inline">
                            <div className="col-12 notspace">
                                <input type={"text"} className="form-control" value={createFlashCardDTO.definition} onChange={e => this.setState((prevState) => {
                                    return { createFlashCardDTO: { ...prevState.createFlashCardDTO, definition: e.target.value } }
                                })} placeholder="توضیحات بیشتر برای کلمه" />
                            </div>
                        </div>
                        <div className="tk-inline py-4">
                            <div className="col-12 notspace personal-content-menu-buttons-area" >
                                <button className="btn btn-primary full-width" onClick={this.create} >ثبت</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    }
}